import AnalysesByEmployee from 'components/dashboard/AnalysesByEmployee';
import AvgWaterTestsPerAccount from 'components/dashboard/avgWaterTestsPerAccount';
import BioguardTotalSales from 'components/dashboard/BioguardTotalSales/bioguardTotalSales';
import BranchApi from 'api/branch';
import classNames from 'classnames';
import DashboardApi from 'api/dashboard';
import DashboardTile from 'components/dashboard/dashboardTile';
import DataCleanup from 'components/dashboard/DataCleanup';
import DealerApi from 'api/dealer';
import events from 'lib/events';
import find from 'lodash/find';
import Header from 'components/layout/header';
import IntlWrapper from 'components/layout/intlWrapper';
import Loader from 'components/loader';
import PropTypes from 'prop-types';
import moment from 'moment';
import PastDueWaterAnalysis from 'components/dashboard/pastDueWater';
import ProblemFollowUp from 'components/dashboard/problemFollowUp';
import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import router from 'lib/router';
import routeUtils from 'util/routeUtils';
import SalesPerformance from 'components/dashboard/salesPerformance';
import session from 'services/sessionService';
import TotalWaterAnalysis from 'components/dashboard/totalWaterAnalysis';
import {connectToPerformanceFile, PERFORMANCE_KEYS} from 'ui/helpers/performanceFile';
import {formatPercentageArrow, formatCurrency, formatPercentage} from 'helpers/dashboardFormatter';
import {FormattedMessage, intlShape, injectIntl} from 'react-intl';
import {bindLocaleUpdate} from 'helpers/bindLocaleUpdate';

// Register in router
const render = container => {
  console.info('[UI.page.pos-dashboard] rendering page');
  ReactDOM.render(<IntlWrapper><WrappedPOSDashboard/></IntlWrapper>, container);
  events.publish('page-change', {page: 'dashboard'});
};


class ExtendedTile extends React.Component {
  static propTypes = {
    children: PropTypes.any,
  };

  state = {
    error: false,
  };

  componentDidCatch(err) {
    console.error(err);

    this.setState({error: true});
  }

  render() {
    if (this.state.error) {
      return <div><FormattedMessage id='article.load.failed'/></div>;
    }

    return this.props.children;
  }
}


console.info('[UI.page.pos-dashboard] register route');
let renderIfAuth = routeUtils.requireAuth(render);

router.rr.add([{path: 'dashboard', handler: renderIfAuth}]);

// Constants
const timeFrameWeek = 'week';
const timeFrameMonth = 'month';
const timeFrameYear = 'year';

class _POSDashboard extends Component {
  static propTypes = {
    intl: intlShape.isRequired,
  };

  constructor(props) {
    super(props);

    const defaultTimeFrame = 'week';

    this.state = {
      user: session.getUser(),
      loaded: false,
      branches: [],
      branchesFull: null,
      dealer: null,
      activeReport: null,
      timeframe: defaultTimeFrame,
      start: moment().startOf(defaultTimeFrame === 'week' ? 'isoweek' : defaultTimeFrame),
      end: moment(),
      endFull: moment().endOf(defaultTimeFrame === 'week' ? 'isoweek' : defaultTimeFrame),
      branch: -1,
      branchOptions: [
        {
          value: -1,
          label: this.props.intl.formatMessage({id: 'general.all.stores'}),
        },
      ],
    };
  }

  componentWillMount() {
    const apis = [];

    apis.push(BranchApi.getMyBranches());
    apis.push(DealerApi.getDealer(this.state.user.dealerId));
    Promise.all(apis)
      .then(([branches, dealer]) => {
        const branchesFilterable = branches.map(b => {
          return {
            value: b.id,
            label: b.name,
          };
        });
        const posPermission = this.checkPOSPermission(this.state.user, dealer);
        let activeReport = 3;

        if (posPermission) {
          activeReport = 1;
        }
        this.setState({
          loaded: true,
          dealer: dealer,
          activeReport: activeReport,
          branchesFull: branches,
          branches: branches.map(b => b.id),
          branchOptions: [...this.state.branchOptions, ...branchesFilterable],
          POS: posPermission,
        });
      })
      .catch(err => {
        console.log('error', err);
      });
  }

  getAnalysesByEmployeeTile = (start, end) => {
    const {branch, branches} = this.state;

    return DashboardApi.getAnalysesByEmployeeTile(branch === -1 ? branches : branch, start, end);
  };

  getAvgWaterTile = () => {
    const {timeframe, branch, branches} = this.state;

    if (timeframe !== 'year') {
      return Promise.resolve('n/a');
    }

    return DashboardApi.getAvgWaterPerAccountTile(branch === -1 ? branches : branch);
  };

  getEmailsTile = () => {
    const {branch, branches} = this.state;

    return DashboardApi.accountWithEmailsTile(branch === -1 ? branches : branch);
  };

  getFollowUpTile = (start, end) => {
    const {branch, branches} = this.state;

    return DashboardApi.getFollowUpTile(branch === -1 ? branches : branch, start, end);
  };

  getPastDueTile = (start, end) => {
    const {branch, branches} = this.state;

    return DashboardApi.getPastDueAnalysisTile(branch === -1 ? branches : branch, start, end);
  };

  // Separate endpoint and call for each 'tile'
  getPerformanceTile = (start, end) => {
    const {branch, branches, timeframe} = this.state;
    let newEnd = end;
    let start2;
    let end2;
    let weeks = moment().weeks();

    if (timeframe === 'week') {
      newEnd = moment().endOf('isoweek');
      start2 = moment().subtract(1, 'year').weeks(weeks).startOf('isoweek');
      end2 = moment().subtract(1, 'year').weeks(weeks).endOf('isoweek');
    }
    return DashboardApi.getSalesPerformanceTile(
      branch === -1 ? branches : branch,
      start,
      newEnd,
      start2 ? start2 : null,
      end2 ? end2 : null);
  };

  getSalesTile = (start, end) => {
    const {branch, branches} = this.state;

    return DashboardApi.getBioGuardTotalSalesTile(branch === -1 ? branches : branch, start, end);
  };

  getTotalWaterTile = (start, end) => {
    const {branch, branches, timeframe} = this.state;

    return DashboardApi.totalWaterAnalysisTile(branch === -1 ? branches : branch, start, end, timeframe);
  };

  changeActiveReport = id => {
    let nextState = {
      activeReport: id,
    };

    if (id === 3 && this.state.timeframe !== 'year') {
      nextState.timeframe = 'year';
      nextState.start = moment().startOf('year');
      nextState.endFull = moment().endOf('year');
    }

    this.setState(nextState);
  };

  checkPOSPermission = (user, dealer) => {
    if (user && dealer && dealer.CurrentPOSIntegration === 0) {
      return false;
    }

    if (user.isDealerAdmin) {
      return true;
    }

    if (user.isAdmin && dealer.managerDashboard) {
      return true;
    }

    return !!(user.isTestStation && dealer.testerDashboard);
  };

  checkTruBlueDealerStatus = () => {
    const {dealer} = this.state;

    if (!this.state.loaded) {
      return false;
    }

    return dealer && dealer.isTruBlueEligible;
  };

  render() {
    const {activeReport, branch, branches, branchOptions, timeframe, start, end, POS, branchesFull, endFull, dealer} = this.state;
    let {formatMessage} = this.props.intl;

    const reportInfo = [
      {
        id: 1,
        component: <ExtendedTile>
          <SalesPerformance POS={POS}
                            onlyPOS={true}
                            start={start}
                            end={end}
                            branch={branch}
                            branches={branches}
                            timeframe={timeframe}
                            dealer={dealer}/>
        </ExtendedTile>,
        tile: <DashboardTile id={1}
                             POS={POS}
                             onlyPOS={true}
                             formatter={formatPercentageArrow}
                             branch={branch}
                             title={formatMessage({id: 'posdashboard.sales.vs.prior'})}
                             activeReport={activeReport}
                             start={start}
                             end={end}
                             onUpdate={this.getPerformanceTile}
                             onActiveChange={this.changeActiveReport}
                             dashOnZero={true}/>,
      },
      {
        id: 2,
        component: <ExtendedTile>
          <BioguardTotalSales start={start}
                              end={end}
                              branch={branch}
                              branches={branches}/>
        </ExtendedTile>,
        tile: <DashboardTile id={2}
                             POS={POS}
                             onlyPOS={true}
                             formatter={formatCurrency}
                             branch={branch}
                             title={formatMessage({id: 'general.total.bioguard.sales'})}
                             activeReport={activeReport}
                             start={start}
                             end={end}
                             onUpdate={this.getSalesTile}
                             onActiveChange={this.changeActiveReport}/>,
      },
      {
        id: 3,
        component: <ExtendedTile>
          <AvgWaterTestsPerAccount POS={POS}
                                   start={start}
                                   end={end}
                                   branch={branch}
                                   branches={branches}
                                   timeframe={timeframe}/>
        </ExtendedTile>,
        tile: <DashboardTile id={3}
                             POS={POS}
                             branch={branch}
                             title={formatMessage({id: 'posdashboard.customer.test.frecuency'})}
                             activeReport={activeReport}
                             start={start}
                             end={end}
                             onUpdate={this.getAvgWaterTile}
                             onActiveChange={this.changeActiveReport}
                             formatter={formatPercentage}/>,
      },
      {
        id: 4,
        component: <ExtendedTile>
          <AnalysesByEmployee start={start}
                              end={end}
                              branch={branch}
                              branches={branches}/>
        </ExtendedTile>,
        tile: <DashboardTile id={4}
                             POS={POS}
                             branch={branch}
                             title={formatMessage({id: 'posdashboard.average.analyses.employee'})}
                             activeReport={activeReport}
                             start={start}
                             end={end}
                             onUpdate={this.getAnalysesByEmployeeTile}
                             onActiveChange={this.changeActiveReport}/>,
      },
      {
        id: 5,
        component: <ExtendedTile>
          <TotalWaterAnalysis timeframe={timeframe}
                              branch={branch}
                              branches={branches}
                              branchesFull={branchesFull}
                              start={start}/>
        </ExtendedTile>,
        tile: <DashboardTile id={5}
                             POS={POS}
                             branch={branch}
                             title={formatMessage({id: 'general.total.water.analyses'})}
                             activeReport={activeReport}
                             start={start}
                             end={end}
                             onUpdate={this.getTotalWaterTile}
                             onActiveChange={this.changeActiveReport}/>,
      },
      {
        id: 6,
        component: <ExtendedTile>
          <ProblemFollowUp timeframe={timeframe}
                           branch={branch}
                           branches={branches}
                           branchesFull={branchesFull}
                           start={start}
                           end={endFull}/>
        </ExtendedTile>,
        tile: <DashboardTile id={6}
                             POS={POS}
                             branch={branch}
                             title={formatMessage({id: 'posdashboard.problem.followups'})}
                             activeReport={activeReport}
                             start={start}
                             end={endFull}
                             onUpdate={this.getFollowUpTile}
                             onActiveChange={this.changeActiveReport}/>,
      },
      {
        id: 7,
        component: <ExtendedTile>
          <PastDueWaterAnalysis POS={POS}
                                start={start}
                                end={end}
                                branch={branch}
                                branches={branches}
                                timeframe={timeframe}/>
        </ExtendedTile>,
        tile: <DashboardTile id={7}
                             POS={POS}
                             branch={branch}
                             title={formatMessage({id: 'posdashboard.pastdue.water.analysis'})}
                             activeReport={activeReport}
                             start={start}
                             end={end}
                             onUpdate={this.getPastDueTile}
                             onActiveChange={this.changeActiveReport}/>,
      },
      {
        id: 8,
        component: <ExtendedTile>
          <DataCleanup getTruBlue={this.checkTruBlueDealerStatus()}
                       branch={branch}
                       branches={branches}
                       title={<h2 className='pos-dashboard-title'>
                         <FormattedMessage id="posdashboard.account.summary"/></h2>}/>
        </ExtendedTile>,
        tile: <DashboardTile id={8}
                             POS={POS}
                             formatter={formatPercentage}
                             branch={branch}
                             title={formatMessage({id: 'posdashboard.contacts.emails'})}
                             activeReport={activeReport}
                             start={start}
                             end={end}
                             onUpdate={this.getEmailsTile}
                             onActiveChange={this.changeActiveReport}
                             dontUpdateOnFilter={true}/>,
      },
    ];

    const reportTiles = reportInfo.map((r, i) => {
      return <div key={i}>
        {r.tile}
      </div>;
    });

    const getDetailedReport = find(reportInfo, {id: activeReport});
    const detailedReport = getDetailedReport ? getDetailedReport.component : <div/>;

    return <div id='page-posdashboard'
                className='container'>
      <Header mainTitle={formatMessage({id: 'dashboard.title'})}/>
      <section className='filter-section'>
        <div className='row'>
          <div className='col-sm-9 timeframe'>
            <label><FormattedMessage id="posdashboard.select.timeframe"/></label>
            <div className='date-group'>
              <button className={classNames('flex-align', 'timeframe-button', {active: timeframe === timeFrameWeek})}
                      disabled={this.state.activeReport === 3}
                      onClick={() => {
                        this.setState({
                          timeframe: timeFrameWeek,
                          start: moment().startOf('isoweek'),
                          endFull: moment().endOf('isoweek'),
                        });
                      }}>
                <span className={timeframe === timeFrameYear ? 'line' : ''}><FormattedMessage id="general.weektodate"/></span>
              </button>
              <button className={classNames('flex-align', 'timeframe-button', {active: timeframe === timeFrameMonth})}
                      disabled={this.state.activeReport === 3}
                      onClick={() => {
                        this.setState({
                          timeframe: timeFrameMonth,
                          start: moment().startOf('month'),
                          endFull: moment().endOf('month'),
                        });
                      }}>
                <span><FormattedMessage id="general.monthtoday"/></span>
              </button>
              <button className={'flex-align ' +
              (timeframe === timeFrameYear ? 'active' : '')}
                      onClick={() => {
                        this.setState({
                          timeframe: timeFrameYear,
                          start: moment().startOf('year'),
                          endFull: moment().endOf('year'),
                        });
                      }}>
                <span className={timeframe === timeFrameWeek ? 'line' : ''}><FormattedMessage id="general.yeartodate"/></span>
              </button>
            </div>
          </div>
          <div className='col-sm-3 editable-selectfield'>
            <div className='form-group'>
              <label><FormattedMessage id="general.select.store"/></label>
              <select className='form-control'
                      value={branch}
                      onChange={e => this.setState({branch: parseInt(e.target.value)})}>
                {branchOptions.map(o => <option key={o.label}
                                                value={o.value}>{o.label}</option>)}
              </select>
            </div>
          </div>
        </div>
      </section>
      <Loader loaded={this.state.loaded}>
        <section className='grid-section'>
          <div className='grid-row row'>
            {reportTiles}
          </div>
        </section>
        <section className='report-section'>
          {detailedReport}
        </section>
      </Loader>
    </div>;
  }
}

const POSDashboard = bindLocaleUpdate(connectToPerformanceFile(PERFORMANCE_KEYS.dashboard)(_POSDashboard));
const WrappedPOSDashboard = injectIntl(POSDashboard);

export default WrappedPOSDashboard;
